import { ORIGEN_LEAD_VALUES, REGEX } from '../config'
import { addInputHiddenForTags } from './addInputHiddenForTags'

export function addOrigingLeadTag() {
  const isMobileDevice = () => REGEX.DEVICES.test(navigator.userAgent)

  const resetTag = () => {
    const $inputForTag = document.querySelector('[name="origen_lead"]')
    $inputForTag?.remove()
  }

  const $requestBudggetBtns = document.querySelectorAll(
    '[aria-label="Pedir Presupuesto"]'
  )

  const $requestBudggetCta = document.querySelectorAll(
    '[id^="cta_landing_formulario_"]'
  )

  const $requestBudggetCta2 = document.querySelectorAll(
    '[id^="cta_web_formulario"]'
  )

  const $callYouCta = document.getElementById('dmvText')

  const $ringpoolDirectCall = document.getElementById('ringPoolCha')

  const $ringpoolHeaderMobile = document.querySelector('.ringpool-wrap a')

  const $ringpoolModal = document.getElementById('ringPoolNumber')

  /**
   *  CALLME_HEADER_DESKTOP
   */
  if ($requestBudggetBtns.length > 0) {
    $requestBudggetBtns.forEach((btn, i) => {
      btn?.addEventListener('click', () => {
        resetTag()

        if (i === 0) {
          addInputHiddenForTags(
            'origen_lead',
            ORIGEN_LEAD_VALUES.CALLME_HEADER_DESKTOP
          )
        } else {
          /**
           * CALLME HEADER MOBILE
           */
          addInputHiddenForTags(
            'origen_lead',
            ORIGEN_LEAD_VALUES.CALLME_HEADER_MOBILE
          )
        }
      })
    })
  }

  /**
   * CALLME DESKTOP STICKY
   */
  if ($requestBudggetCta.length > 0) {
    $requestBudggetCta.forEach((btn, i) => {
      btn?.addEventListener('click', () => {
        resetTag()
        if (i === 0) {
          addInputHiddenForTags(
            'origen_lead',
            ORIGEN_LEAD_VALUES.CALLME_DESKTOP_STICKY
          )
        } else {
          addInputHiddenForTags(
            'origen_lead',
            ORIGEN_LEAD_VALUES.CALLME_DESKTOP_BOTON_CMS
          )
        }
      })
    })
  }

  /**
   * CALLME DESKTOP STICKY (otra variante de cta)
   */

  if ($requestBudggetCta2.length > 0) {
    $requestBudggetCta2.forEach((btn, i) => {
      btn?.addEventListener('click', () => {
        resetTag()
        if (i === 0) {
          addInputHiddenForTags(
            'origen_lead',
            ORIGEN_LEAD_VALUES.CALLME_DESKTOP_STICKY
          )
        } else {
          addInputHiddenForTags(
            'origen_lead',
            ORIGEN_LEAD_VALUES.CALLME_DESKTOP_BOTON_CMS
          )
        }
      })
    })
  }

  /**
   * CALLME MOBILE CTA
   */

  $callYouCta?.addEventListener('click', () => {
    resetTag()
    addInputHiddenForTags('origen_lead', ORIGEN_LEAD_VALUES.CALLME_MOBILE_CTA)
  })

  const addTagForRingpoolLeads = ({ element, value }) => {
    element?.addEventListener('click', () => {
      window.DFI.labels.EDeclaratives = {
        ...window.DFI.labels.EDeclaratives,
        origen_lead: value
      }

      const labels = {
        EDeclaratives: window.DFI.labels.EDeclaratives
      }
      window.DRP.loadLabels(labels)
    })
  }

  /**
   * RINGPOOL MOBILE CTA
   */

  if (isMobileDevice()) {
    addTagForRingpoolLeads({
      element: $ringpoolDirectCall,
      value: ORIGEN_LEAD_VALUES.RINGPOOL_MOBILE_CTA
    })

    /**
     * RINGPOOL MOBILE HEADER
     */
    addTagForRingpoolLeads({
      element: $ringpoolHeaderMobile,
      value: ORIGEN_LEAD_VALUES.RINGPOOL_MOBILE_HEADER
    })

    /**
     * RINGPOOL MOBILE MODAL
     */
    addTagForRingpoolLeads({
      element: $ringpoolModal,
      value: ORIGEN_LEAD_VALUES.RINGPOOL_MOBILE_MODAL
    })
  }
}
